/* eslint-disable no-useless-computed-key */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { Col, Image, Row, Space, Modal } from "antd";
import {
    Button, TextField, Box, Switch, InputLabel, TableRow, TableCell, FormControlLabel,
    Checkbox, Typography, Tooltip, InputAdornment
} from "@mui/material";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DateIcon from "../../../../Shared/components/Icons/Date";
import { emptyValidation } from "../../../../../helpers/validation";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import gstActions from "../../../../Admin/Setup/redux/actions";
import actions from "../../redux/actions";
import { toast } from 'react-toastify';
import moment from 'moment';
import { capitalizeFirstLetter, currencyFormat, checkCRUDViewPermission, checkCRUDPermission, scrollToError, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import { selectInvoiceHead } from "../../../../../config/constant";
import transactionsActions from "../../../Transactions/redux/actions";
import businessActions from "../../../../Admin/Home/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import IconButton from '@mui/material/IconButton';
import CustomAlert from "../../../../Shared/components/CustomAlert";
import dayjs from 'dayjs';
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { useEventListener } from "../../../../../helpers/useEventListener"
import { CustomModal } from "../../../../Shared/components/DeleteModal";

const CustomerPaymentEdit = (props) => {
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { salesInvoiceDetails } = useSelector(state => state.salesTransactionsReducer);
    const { getTeamData } = useSelector(state => state.homeReducer);
    const { currencyDetails, mopDetails } = useSelector(state => state.adminSetupReducer);
    const { readDetails, readError, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const { history, onRequestSort, sortOrder, sortBy } = props;
    let { paymentId } = useParams();
    const decryptedId = AESDecrypt(paymentId);
    const [customerId, setCustomerId] = useState('');
    const [customerSerialNo, setCustomerSerialNo] = useState('');
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [mopId, setMopId] = useState('');
    const [salesRepId, setSalesRepId] = useState('');
    const [amount, setAmount] = useState(0);
    const [hiddenAmount, setHiddenAmount] = useState(0);
    const [currencyId, setCurrencyId] = useState('');
    const [reference, setReference] = useState('');
    //const [status, setStatus] = useState('CREATED');

    const [description, setDescription] = useState('');
    const [selected, setSelected] = useState([]);
    const [paymentAmount, setPaymentAmount] = useState(0.00);
    const [balanceAmount, setBalanceAmount] = useState(0.00);
    const [markedAmount, setMarkedAmount] = useState(0.00);
    const [autoMark, setAutoMark] = useState(false);
    const [items, setItems] = useState([]);

    const childRef = useRef('');

    const [errorCustomerId, setErrorCustomerId] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    //const [errorMopId, setErrorMopId] = useState(false);
    const [errorAmount, setErrorAmount] = useState(false);
    const [errorDate, setErrorDate] = useState(false);
    const [errorCommon, setErrorCommon] = useState(false);

    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [showDetails, setShowDetails] = useState(true);
    const [confirm, setConfirm] = useState(false)
    const { roleManagement } = useSelector(state => state.authReducer);

    const dispatch = useDispatch();

    const handleOk = () => {
        setIsModalVisible(false);
    };


    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const emptyState = () => {
        setErrorCustomerId(false);
        setErrorCurrency(false);
        // setErrorMopId(false);
        setErrorAmount(false);
        setErrorCommon(false);
    }

    useEffect(() => {
        if (paymentId === undefined || decryptedId === 0) {
            history.push("/sales/sales-management/customer-payment");
            return true;
        }

        if (roleManagement !== '' && checkCRUDViewPermission('Customer Payment', 'edit', history, 'Sales')) {
            dispatch({
                type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: businessActions.TEAM_DETAILS_START, url: 'team', filter: {
                    order: 'id  desc'
                }
            });
            // dispatch({
            //     type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
            //         order: 'id desc'
            //     }
            // });
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "customerPayment" });
        }

        return () => {
            dispatch({ type: transactionsActions.CLEAR_SALES_TRANSACTION_DETAILS_START });
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_START });
        }
    }, [paymentId, roleManagement]);


    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            handleConfirmSubmit();
        } else if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            if (confirm) {
                handleSubmit('', 'CONFIRMED');
            } else {
                handleSubmit(e);
            }
        }
    };

    useEventListener("keydown", handleKeyDown);


    const handleConfirmSubmit = () => {
        childRef?.current?.handleAdjustHeight();
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        //let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptyCustomer.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            setConfirm(true);
        } else {
            setConfirm(false);
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            // if (emptyMopId.errors) {
            //     setErrorMopId(emptyMopId.errors);
            // }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    }



    useEffect(() => {
        setItems(salesInvoiceDetails);
        calculatePaymentTotal(salesInvoiceDetails, 0);
        childRef?.current?.handleAdjustHeight();
    }, [salesInvoiceDetails]);


    const handleSubmit = (e = '', status = 'CREATED') => {
        if (e !== '') {
            e?.preventDefault();
        }
        childRef?.current?.handleAdjustHeight();
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        // let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptyCustomer.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            // setStatus(status);
            let sItems = [];
            let mItems = '';
            var eItems = items.filter((el) => { return selected.find(e => e === el.id) });
            eItems && eItems.length > 0 && eItems.map((element, i) => {
                mItems = {
                    salesInvoiceId: element.id,
                    amountToSettle: parseFloat(element.costAmount),
                    fullySettled: (parseFloat(parseFloat(element.costAmount).toFixed(2)) === parseFloat(parseFloat(element.invoiceAmount - element.settledAmount).toFixed(2))) ? true : false
                };
                sItems.push(mItems);
            });
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                id: decryptedId,
                url: 'customerPayment',
                title: 'Customer Payment',
                details: {
                    customerId: customerId,
                    date: paymentDate,
                    paymentAmount: parseFloat(parseFloat(hiddenAmount).toFixed(2)),
                    reference: reference,
                    paymentStatus: status,
                    description: description,
                    mopId: mopId || null,
                    salesRepId: salesRepId || null,
                    currencyId: currencyId,
                    markedAmount: parseFloat(parseFloat(markedAmount).toFixed(2)),
                    items: sItems
                }
            })
        } else {
            setConfirm(false);
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            // if (emptyMopId.errors) {
            //     setErrorMopId(emptyMopId.errors);
            // }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    };


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            setConfirm(false)
            if (roleManagement !== '' && checkCRUDPermission('Customer Payment', 'view', 'Sales')) {
                history.push(`/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/view`, 'edit');
            } else {
                history.push(`/sales/sales-management/customer-payment`);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails.paymentStatus === 'CONFIRMED' || readDetails.paymentStatus === 'CANCELLED' || readDetails.paymentStatus === 'REVERSED') {
                toast.error('This payment is already ' + (readDetails.paymentStatus));
                history.push('/sales/sales-management/customer-payment');
            } else if (readDetails?.supplier?.isHold) {
                toast.error('Please release the Customer Invoice from ON-HOLD to allow for transaction to be processed.');
                history.push('/sales/sales-management/customer-payment');
            }
            customerApi('', readDetails.customerId);
            setCustomerId(readDetails.customerId);
            setCustomerSerialNo(readDetails?.customer?.serialNo ? readDetails?.customer?.serialNo : '---');
            setMopId(readDetails?.mopId || '');
            setSalesRepId(readDetails?.salesRepId || '');
            setAmount(readDetails.paymentAmount - readDetails.markedAmount);
            setHiddenAmount(readDetails.paymentAmount);
            setPaymentDate(dayjs(readDetails?.date).$d || new Date());
            setCurrencyId(readDetails.currencyId);
            setReference(readDetails.reference);
            setDescription(readDetails.description);
            // setStatus(readDetails.paymentStatus);

            setItems(readDetails.items);
            let seletedItems = [];
            readDetails?.customerPaymentItems && readDetails.customerPaymentItems.map(function (el) {
                seletedItems.push(el?.salesInvoice?.id);
            });

            setSelected(seletedItems);
            //setAutoMark(readDetails.customerPaymentItems && readDetails.customerPaymentItems.length > 0 ? true : false);
            calculatePaymentTotal(readDetails.items, (readDetails.paymentAmount - readDetails.markedAmount));
            setShowDetails(false);
            //handleCustomer(readDetails.customerId);
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            if (readError.error.statusCode) {
                toast.error('Payment ID is invalid');
                history.push('/sales/sales-management/customer-payment');
            }
        }
    }, [readDetails, readError]);

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const handleChangeCustomer = (id) => {
        let cId = id;
        setAutoMark(false);
        emptyState();
        let a = customerDetails.filter(function (el) { return el.id === cId });
        if (a && a?.length !== 0) {
            if (a && a?.length !== 0) {
                if (a[0]?.isHold) {
                    cId = 0;
                    setCustomerId('');
                    setMopId('');
                    setSalesRepId('');
                    setCurrencyId('');
                    setCustomerSerialNo('');
                    setErrorCustomerId('Please release the Customer Invoice from ON-HOLD to allow for transaction to be processed.');
                } else {
                    setMopId(a[0].mopId > 0 ? a[0].mopId : '');
                    setCurrencyId(a[0].currencyId && a[0].currencyId);
                    setCustomerId(cId);
                    setSalesRepId(a[0]?.salesRepId || '');
                    setCustomerSerialNo(a[0].serialNo);
                }
            }
        }
        handleCustomer(cId);
        setSelected([]);
        setMarkedAmount(0);
        setBalanceAmount(0);
        setHiddenAmount(amount);
    }


    const handleCustomer = (id) => {
        let filter = { ["and"]: [{ customerId: id }, { isSettled: false }] };
        let or = { ["or"]: [{ source: 'SALES SELF BILL' }, { source: 'STORE SALES INVOICE' }, { source: 'SALES ORDER' }] };
        filter['and'].push(or);
        dispatch({
            type: transactionsActions.SALES_INVOICE_DETAILS_START,
            url: 'salesInvoice',
            filter: {
                where: filter,
                order: 'invoiceDate ASC',
            }
        });
    }


    useEffect(() => {
        calculatePaymentTotal(items ? items : [], amount);
    }, [customerId]);


    const handleClick = (e, data, invoiceId) => {
        if (e.target.checked) {
            if (amount > 0) {
            } else {
                toast.dismiss();
                toast.error('Amount less than invoice amount');
                return false;
            }
        }
        setAutoMark(false);
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
        calculatePayment(e, data, invoiceId, newSelected);
    };


    const calculatePayment = (e, data, invoiceId, selected) => {
        let mLines = [];
        for (const [key, value] of Object.entries(data)) {
            mLines[key] = value
        }
        let tAmount = 0;
        let autoAmount = parseFloat(amount);
        if (e.target.name === 'auto') {
            let autoMarkDiv = document.getElementById('autoMark');
            autoAmount = autoMarkDiv.getAttribute('dataamount');
        }
        let selectedArray = [];
        if (e.target.name === 'costAmount' && e.target.value !== '') {
            if (parseFloat(e.target.value) <= parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) {
                mLines['costAmount'] = parseFloat(parseFloat(e.target.value).toFixed(2));
            } else {
                mLines['costAmount'] = parseFloat(parseFloat(parseFloat(data.invoiceAmount) - parseFloat(data.settledAmount)).toFixed(2));
            }
        } else {
            if (e.target.checked) {
                if (autoAmount > (data.invoiceAmount - data.settledAmount)) {
                    mLines['costAmount'] = parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2));
                    tAmount = parseFloat(autoAmount - parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)));
                } else {
                    mLines['costAmount'] = parseFloat(parseFloat(autoAmount).toFixed(2));
                    tAmount = parseFloat(parseFloat(autoAmount - autoAmount).toFixed(2));
                }
            } else {
                tAmount = parseFloat(parseFloat(autoAmount + data.costAmount).toFixed(2));
                mLines['costAmount'] = 0;
            }
        }
        let index = items.findIndex((d, i) => invoiceId === i);
        if (index >= 0) {
            items.splice(index, 1, mLines);
        }
        if (e.target.name === 'costAmount' && e.target.value !== '') {
            selectedArray = items.filter(function (el) { return selected.find(e => e === el.id) && !el.onHold });
            let tcAmount = parseFloat(selectedArray.reduce((a, v) => a = parseFloat(a) + parseFloat(v.costAmount), 0));
            tAmount = parseFloat(hiddenAmount) - parseFloat(tcAmount);
            if (hiddenAmount < tcAmount) {
                toast.dismiss();
                toast.error('Payment available only Rs.' + hiddenAmount);
                mLines['costAmount'] = currencyFormat(data.costAmount);
                items.splice(index, 1, mLines);
                return false;
            }
        }
        calculatePaymentTotal(items, tAmount);
    }

    const calculatePaymentTotal = (items, a) => {
        let markedAmount = items ? items.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v.costAmount)), 0) : 0.00;
        setPaymentAmount(hiddenAmount);
        setMarkedAmount(markedAmount);
        setBalanceAmount(parseFloat(parseFloat(parseFloat(hiddenAmount).toFixed(2)) - markedAmount));
        setAmount(a);
    }

    const handleCostAmount = (e, data, costIndex) => {
        setAutoMark(false);
        calculatePayment(e, data, costIndex, selected);
    }

    const handleAmount = (value) => {
        setAmount(value);
        setHiddenAmount(value);
    }

    const handleAutomark = (e) => {
        setAutoMark(e.target.checked);
        let newSelected = [];
        resetSelected();
        if (e.target.checked) {
            items && items.length > 0 && items.map((data, i) => {
                let e = { 'target': { 'name': "auto", "checked": true } };
                setTimeout(function () {
                    if (data.onHold) {
                        return null;
                    }
                    let autoMarkDiv = document.getElementById('autoMark');
                    if (autoMarkDiv.getAttribute('dataamount') > 0) {

                    } else {
                        return false;
                    }
                    newSelected.push(data.id);
                    calculatePayment(e, data, i, newSelected);
                });
            });
        }
        setSelected(newSelected);
    }

    const resetSelected = () => {
        items && items.length > 0 && items.map((data, si) => {
            let mLines = [];
            for (const [key, value] of Object.entries(data)) {
                mLines[key] = value
            }
            mLines['costAmount'] = 0;
            let index = items.findIndex((d, i) => si === i);
            if (index >= 0) {
                items.splice(index, 1, mLines);
            }
        });
        setPaymentAmount(0);
        setMarkedAmount(0);
        setBalanceAmount(0);
        setAmount(hiddenAmount);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleUnAutomark = (e) => {
        e.target.checked = false;
        handleAutomark(e);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                cls={'newImg'}
                img={SalesIcon}
                closeLink={'/sales/sales-management/customer-payment'}
                title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Payments', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Edit Payment'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails &&
                                    <Box
                                        className={clsx(classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleSubmit(e)}>
                                        <Row gutter={50} className={clsx(classes.ButtonRelative)}>
                                            {
                                                errorCommon && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <CustomAlert error={errorCommon} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                                </Col>
                                            }
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.bold, classes.disInline)}>{readDetails?.serialNo}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={14}>
                                                <span className={clsx(classes.statusButton, classes.collectPayment, classes.disInline, { [classes.confirmedButton]: readDetails.paymentStatus === 'CONFIRMED' }, { [classes.reversedButton]: readDetails.paymentStatus === 'CANCELLED' })}>{capitalizeFirstLetter(readDetails.paymentStatus)}</span>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={12} md={8} sm={12} xs={10} className={clsx(classes.textAlignRight, classes.ButtonStatic, classes.collectPayment, classes.displayFlexPayment)}>
                                                <Space direction="horizontal" align="center" size={[10, 10]} className={clsx(classes.ButtonAbsolute, classes.OverallPaymentButton)}>
                                                    {
                                                        (readDetails.paymentStatus === 'CREATED') &&
                                                        <>
                                                            <Button
                                                                tabIndex={-1}
                                                                key="confirm"
                                                                color="primary"
                                                                onClick={() => handleConfirmSubmit()}
                                                                variant="contained"
                                                                id={idNamingConversion('Confirm', 'customerPayment', 'Button')}
                                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: editLoader })}
                                                            >Confirm</Button>
                                                            <Button
                                                                tabIndex={-1}
                                                                key="save"
                                                                color="primary"
                                                                variant="contained"
                                                                type={'submit'}
                                                                id={idNamingConversion('Save', 'customerPayment', 'Button')}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                                            >Save</Button>
                                                        </>
                                                    }
                                                    {
                                                        (readDetails.paymentStatus === 'CONFIRMED') &&
                                                        <>
                                                            <Button
                                                                key="save"
                                                                color="primary"
                                                                variant="contained"
                                                                id={idNamingConversion('Cancel', 'customerPayment', 'Button')}
                                                                onClick={(e) => handleSubmit(e, 'REVERSED')}
                                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                                                            >Cancel</Button>
                                                        </>
                                                    }

                                                </Space>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                                    { 'key': 'mobile', 'name': 'Phone Number' },
                                                    { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                                    details={customerDetails}
                                                    id={idNamingConversion('Customer Name', 'customerPayment', 'DropDown')}
                                                    searchType={(s) => customerApi(s)}
                                                    parentValue={customObject(customerDetails, customerId)}
                                                    onChange={(data) => { handleChangeCustomer(data.id) }}
                                                    parentError={errorCustomerId}
                                                    customClasses={classes.margin20t}
                                                    position={"bottom"}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</InputLabel>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{customerSerialNo || '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <div className={clsx(classes.margin25t, classes.dateAdjust)}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            fullWidth
                                                            error={errorDate && true}
                                                            helperText={errorDate}
                                                            slots={{
                                                                openPickerIcon: DateIcon
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            value={paymentDate}
                                                            label="Payment Date"
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    id: idNamingConversion('Payment Date', 'customerPayment', 'TextField'),
                                                                    autoComplete: 'one-time-code'
                                                                },
                                                            }}
                                                            InputLabelProps={{
                                                                required: true
                                                            }}
                                                            format="dd/MM/yyyy"
                                                            onChange={(newValue) => { setPaymentDate(newValue) }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Method of payment (MOP) "]}
                                                    heads={[{ 'key': 'method', 'name': 'Method' },
                                                    { 'key': 'description', 'name': 'Description' }]}
                                                    details={mopDetails}
                                                    id={idNamingConversion('Method of payment', 'customerPayment', 'DropDown')}
                                                    parentValue={customObject(mopDetails, mopId)}
                                                    onChange={(data) => setMopId(data.id)}
                                                    position={"bottom"}
                                                    customClasses={classes.margin25t}
                                                //  parentError={errorMopId}
                                                />
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Sales Rep "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    id={idNamingConversion('Sales Rep', 'customerPayment', 'DropDown')}
                                                    details={getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE')}
                                                    parentValue={customObject(getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE'), salesRepId)}
                                                    onChange={(data) => { console.log(data); setSalesRepId(data.id) }}
                                                    position={"bottom"}
                                                    customClasses={classes.margin25t}
                                                //parentError={errorMopId}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                                    heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                                    { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                                    details={currencyDetails}
                                                    id={idNamingConversion('Currency', 'customerPayment', 'DropDown')}
                                                    parentValue={customObject(currencyDetails, currencyId)}
                                                    onChange={(data) => setCurrencyId(data.id)}
                                                    parentError={errorCurrency}
                                                    position={"bottom"}
                                                    customClasses={classes.margin25t}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label={["Payment Amount ", <span key={"Payment Amount"} className={classes.colorRedRequired}> *</span>]}
                                                    fullWidth
                                                    type="number"
                                                    id={idNamingConversion('Payment Amount', 'customerPayment', 'TextField')}
                                                    value={hiddenAmount}
                                                    onWheel={(e) => e.target.blur()}
                                                    variant={'standard'}
                                                    error={errorAmount && true}
                                                    helperText={errorAmount}
                                                    className={clsx(classes.margin25t, { [classes.disabled]: selected && selected.length !== 0 })}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    inputProps={{
                                                        step: "any",
                                                        "aria-autocomplete": "none"
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom
                                                    }}
                                                    onFocus={(e) => { parseFloat(e.target.value) === 0 ? handleAmount('') : handleAmount(parseFloat(e.target.value)) }}
                                                    onBlur={(e) => { e.target.value === '' ? handleAmount(0) : handleAmount(parseFloat(e.target.value)) }}
                                                    onChange={(e) => handleAmount(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Payment Reference (Optional)'
                                                    fullWidth
                                                    value={reference}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin25t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    id={idNamingConversion('Payment Reference', 'customerPayment', 'TextField')}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setReference(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <TextField autoComplete='one-time-code'
                                                    label='Description (Optional)'
                                                    fullWidth
                                                    value={description}
                                                    variant={'standard'}
                                                    className={clsx(classes.margin25t)}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    id={idNamingConversion('Description', 'customerPayment', 'TextField')}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Payment Status</InputLabel>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.paymentStatus !== '' ? capitalizeFirstLetter(readDetails.paymentStatus) : '---'}</Typography>
                                            </Col>
                                        </Row>
                                    </Box>
                                }
                                {
                                    (showDetails === true) && (
                                        <div className={classes.textAlignCenter}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }

                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Select Invoice'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <div className={clsx(classes.tableRoot, classes.tableRootSelectInvoice)} style={{ height: "100%" }}>
                                <div className={classes.overFlowSelectiveAuto}>
                                    <Row gutter={20} align="middle" style={{ marginBottom: 8 }} className={classes.overFlowSelective}>
                                        <Col xxl={4} xl={4} lg={5} md={5} sm={5} xs={5} >
                                            <div id="autoMark" className={clsx(classes.disInline, classes.verticalAlignMiddle, classes.fontSize0)} dataamount={amount}>
                                                <Tooltip style={{ marginRight: 10 }}
                                                    classes={{ popper: clsx(classes.customToolTip) }}
                                                    title="Enable Auto Mark for the system to automatically select the Invoices" arrow
                                                    placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <div className={clsx(classes.disInline, classes.verticalAlignMiddle)}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize14, classes.textFieldLableAutoMark, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'),

                                                    }}
                                                    control={<Switch size='small' className={clsx(classes.customSwitch, classes.marginLeft10)}
                                                        onChange={(e) => handleAutomark(e)}
                                                    />}
                                                    id={idNamingConversion('Auto Mark', 'customerPayment', 'Radio')}
                                                    label="Auto Mark"
                                                    labelPlacement="start"
                                                    checked={autoMark}
                                                    disabled={hiddenAmount === 0 ? true : false}
                                                    className={clsx(classes.marginLeft0)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xxl={16} xl={16} lg={15} md={15} sm={15} xs={15} className={classes.textAlignCenter}>
                                            <div className={clsx(classes.amountBorder)}>
                                                <div className={clsx(classes.amountBorderCenterAlign)}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Payment Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(paymentAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Marked Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(markedAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Balance Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(balanceAmount)}</span></Typography>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} className={clsx(classes.textAlignRight, classes.textLeft)}>
                                            <Button
                                                key="confirm"
                                                type="submit"
                                                color="primary"
                                                id={idNamingConversion('Un-Mark', 'customerPayment', 'Button')}
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn)}
                                                onClick={(e) => handleUnAutomark(e)}
                                            >Un-Mark</Button>
                                        </Col>
                                    </Row>
                                </div>

                                <CustomInfiniteScroll
                                    heads={selectInvoiceHead}
                                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                                    sortOrder={sortOrder}
                                    width={true}
                                    sortBy={sortBy}
                                    selected={selected}
                                    loadMore={true}
                                    loadMoreContent={false}
                                    onSelected={(value) => setSelected(value)}
                                    component={
                                        <>
                                            {
                                                showDetails === true ? (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            showDetails === false && items && items.length > 0 ? items.map((data, i) => (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx({ [classes.disabled]: data?.onHold })} key={i}>
                                                                    <TableCell>
                                                                        {
                                                                            !data?.onHold &&
                                                                            <Checkbox checked={selected && selected.find(e => e === data.id) ? true : false} id={`checkbox_${i}`} className={clsx({ [classes.disabled]: amount === '' || (data.invoiceAmount - data.settledAmount === 0) || data.billStatus === 'REVERSED' })} onChange={(e) => handleClick(e, data, i)} />
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectInvoiceHead, 1) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>{data.serialNo}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectInvoiceHead, 2) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 2) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectInvoiceHead, 3) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(selectInvoiceHead, 3) }}>₹ {data.invoiceAmount ? currencyFormat(data.invoiceAmount - data.settledAmount) : '0.00'}</span></TableCell>
                                                                    <TableCell className={classes.textAlignRight} style={{ width: getColumnWidth(selectInvoiceHead, 4) }}>
                                                                        <span style={{ width: getColumnWidth(selectInvoiceHead, 4) }}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                fullWidth
                                                                                type={'number'}
                                                                                name="costAmount"
                                                                                id={idNamingConversion(`Cost Amount_${i}`, 'customerPayment', 'Radio')}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                value={data.costAmount && data.costAmount > 0 ? data.costAmount : (selected.find(e => e === data.id) ? "" : 0)}
                                                                                className={clsx(classes.textAreaAdjust, classes.dataCostAmount, { [classes.dataCostAmountText]: selected.find(e => e === data.id) })}
                                                                                // multiline={true}
                                                                                onChange={(e) => handleCostAmount(e, data, i)}
                                                                                InputProps={{
                                                                                    startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                                    classes: {
                                                                                        input: classes.textFieldColor,
                                                                                    },
                                                                                    step: "any",
                                                                                }}
                                                                                InputLabelProps={{
                                                                                    className: classes.textAreaLableColorCustom,
                                                                                }}
                                                                            /></span>
                                                                    </TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectInvoiceHead, 5) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>₹ {data.invoiceAmount ? currencyFormat(parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)) - parseFloat(data.costAmount)) : '0.00'}</span></TableCell>
                                                                    <TableCell className={clsx(classes.textAlignRight)} style={{ width: getColumnWidth(selectInvoiceHead, 6) }}>
                                                                        <span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>  {data?.onHold ? <span style={{ display: "inline-block" }} className={clsx(classes.statusButton)}>Hold</span> :
                                                                            <span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.openButton]: data.costAmount === null || data.costAmount === 0 }, { [classes.fullButton]: (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) })}>
                                                                                {
                                                                                    (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) ? "Full" : data.costAmount === null || data.costAmount === 0 ? "Open" : "Partial"
                                                                                }
                                                                            </span>
                                                                        }
                                                                        </span>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : (<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                <TableCell className={classes.textAlignCenter} colSpan={8}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Currently there is no open invoice to settle against payment'}</p></TableCell>
                                                            </TableRow>)
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </div>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <Modal
                title={'System Override Confirmation'}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                    // onClick={() => deleteBill()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => handleCancel()}
                    >
                        No
                    </Button>,
                ]}
            >
                <p>Do you want to override system selected Invoices to settle?</p>
            </Modal>
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                loading={editLoader}
                title={'Payment Confirmation'}
                onOpen={() => handleSubmit('', 'CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={<p>Are you sure do you want to Confirm the Payment?</p>}
            />
        </React.Fragment>
    )
}
export default CustomerPaymentEdit